precision highp float;

varying vec2 vUv;
uniform float uTime;
uniform float uHover;
uniform float uAudioLevel;
uniform float uBass;
uniform float uTreble;
uniform vec3  uObjectColor;
uniform vec3  uBgColor;
uniform int   uWaveCount;
uniform float uWaveDir;   // 0–360 degrees, rotates entire wave field
uniform int   uGradientIdx;
uniform float uScale;

vec3 neonGradient(float t, vec3 tint) {
    t = clamp(t, 0.0, 1.0);
    vec3 c0 = vec3(0.0,  1.0,  0.4);
    vec3 c1 = vec3(0.0,  0.75, 1.0);
    vec3 c2 = vec3(0.15, 0.15, 1.0);
    vec3 c3 = vec3(0.55, 0.0,  1.0);
    vec3 c4 = vec3(1.0,  0.0,  0.55);
    float s = t * 4.0;
    vec3 col = mix(c0, c1, clamp(s,       0.0, 1.0));
    col = mix(col, mix(c1, c2, clamp(s - 1.0, 0.0, 1.0)), step(1.0, s));
    col = mix(col, mix(c2, c3, clamp(s - 2.0, 0.0, 1.0)), step(2.0, s));
    col = mix(col, mix(c3, c4, clamp(s - 3.0, 0.0, 1.0)), step(3.0, s));
    return mix(col, tint, 0.5);
}

vec3 getGradient(float t, vec3 tint, int idx) {
    if (idx == 1) return mix(vec3(0.8, 0.05, 0.0), vec3(1.0, 0.95, 0.1), clamp(t, 0.0, 1.0));
    if (idx == 2) return mix(vec3(0.0, 0.05, 0.5), vec3(0.0, 0.9,  1.0), clamp(t, 0.0, 1.0));
    if (idx == 3) return mix(tint * 0.2, min(tint + vec3(0.3), vec3(1.0)),  clamp(t, 0.0, 1.0));
    return neonGradient(t, tint);
}

void main() {
    vec2 uv = vUv;
    uv = (uv - 0.5) / max(uScale, 0.01) + 0.5;

    // Rotate the entire wave field by uWaveDir degrees around center (0.5, 0.5)
    float tiltRad = uWaveDir * (3.14159265 / 180.0);
    float ct = cos(tiltRad), st = sin(tiltRad);
    vec2  ctr    = vec2(0.5);
    vec2  tilted = vec2(
        ct * (uv.x - ctr.x) - st * (uv.y - ctr.y) + ctr.x,
        st * (uv.x - ctr.x) + ct * (uv.y - ctr.y) + ctr.y
    );

    vec3  finalCol   = uBgColor;
    float waveSpread = 0.6 / float(uWaveCount);

    for (int i = 0; i < 12; i++) {
        if (i >= uWaveCount) break;
        float idx = float(i);

        float rowPos = 0.2 + idx * waveSpread;
        float freq   = 3.5 + idx * 0.7;
        float spd    = 1.2 + idx * 0.3;
        float phase  = idx * 2.1;

        float isLow = step(idx, float(uWaveCount) * 0.35);
        float amp   = mix(0.03 + uTreble * 0.08, 0.04 + uBass * 0.12, isLow);

        float y    = sin(tilted.x * freq + uTime * spd + phase) * amp + rowPos;
        float dist = abs(tilted.y - y);

        float masterBrightness = (0.4 + uAudioLevel * 0.6) * (1.0 + uHover * 0.3);
        vec3  gradCol = getGradient(tilted.x, uObjectColor, uGradientIdx);

        finalCol += vec3(1.0) * smoothstep(0.003, 0.0, dist) * masterBrightness
                  + gradCol * exp(-dist * 45.0) * 0.75 * masterBrightness
                  + gradCol * 0.45 * exp(-dist * 14.0) * 0.38 * masterBrightness;
    }

    // Vignette in original (non-rotated) UV space to avoid corner clipping
    float v = smoothstep(1.3, 0.25, length(uv - 0.5));
    finalCol *= mix(vec3(0.0), vec3(1.0), v);

    gl_FragColor = vec4(finalCol, 1.0);
}
